<template>
  <Popover ref="popover">
    <template #trigger="{ props }">
      <AppTooltip>
        <template #activator="{ props: tooltipProps }">
          <app-button
            v-bind="{ ...props, ...tooltipProps }"
            size="small"
            type="icon"
          >
            <app-icon-ds icon="trash-can" size="xs" class="text-grey-darken-1" />
          </app-button>
        </template>
        <span>{{ $t('common.delete') }}</span>
      </AppTooltip>
    </template>

    {{ $t('common.deleteConfirmationText') }}

    <template #actions>
      <app-button
        size="small"
        type="outlined"
        variant="neutral"
        @click="close"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        size="small"
        variant="danger"
        @click="confirmDelete"
      >
        {{ $t('common.confirmDelete') }}
      </app-button>
    </template>
  </Popover>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import Popover from './Popover.vue'

export default {
  name: 'DeletePopover',
  components: { AppTooltip, Popover },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ['confirm'],
  methods: {
    confirmDelete () {
      this.$emit('confirm', this.item)
      this.close()
    },
    close () {
      this.$refs.popover?.close()
    },
  },
}
</script>
